export default __webpack_public_path__ + "static/media/CustomManageMembersPerks.da4c9f42.png";